import { useState, useEffect } from 'react';
import beTwMerge from '@/utils/beTwMerge';
import { IHeader, ISubHeader } from '@/types/builder';

export default function Header({ label, link, subheaders = [] }: IHeader) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(typeof window !== 'undefined' && window.innerWidth > 1023);
  }, []);

  const handleOpenMenu = () => {
    if (link) {
      window.location.href = link;
    }
    setIsOpen(!isOpen);
  };

  const getTitle = () => {
    if (subheaders.length > 0) {
      return (
        <div className="tw-w-full tw-font-avenirmedium tw-leading-[19.12px] tw-not-italic tw-text-wrap tw-text-be-dark-gray tw-m-0 hover:tw-no-underline bs-tablet:tw-text-[14px] hover:tw-text-[#0D6363]">
          {label}
        </div>
      );
    }

    return (
      <div
        className={beTwMerge(
          'tw-w-full tw-font-avenirmedium tw-leading-[19.12px] tw-not-italic tw-text-wrap tw-text-be-dark-gray tw-m-0 hover:tw-no-underline bs-tablet:tw-text-[14px] hover:tw-text-[#0D6363]',
          subheaders.length > 0 || !link ? 'tw-pointer-events-none hover:tw-text-[#0D6363]' : ''
        )}
      >
        {label}
      </div>
    );
  };

  return (
    <div
      className={beTwMerge(
        'tw-w-full tw-flex tw-flex-col tw-border-b tw-border-b-[#E5E5E5] tw-border-l-0 tw-border-t-0 tw-border-r-0 tw-border-solid bs-tablet:tw-gap-0',
        isOpen ? 'tw-gap-[8px]' : ''
      )}
    >
      <div
        role="button"
        className={`tw-w-full tw-py-[10px] tw-flex tw-gap-[8px] tw-justify-between tw-items-center ${subheaders.length > 0 || link ? 'hover:tw-cursor-pointer' : ''}`}
        onClick={handleOpenMenu}
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') handleOpenMenu();
        }}
      >
        {label && getTitle()}
        <svg
          className={beTwMerge(
            'tw-shrink-0 tw-w-[20px] tw-h-[20px]',
            subheaders?.length > 0 ? 'tw-d' : 'tw-hidden',
            isOpen ? 'tw-rotate-[-180deg]' : ''
          )}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path d="M17 6L10 13L3 6" stroke="#2C2C2C" />
        </svg>
      </div>

      <div
        className={beTwMerge(
          'tw-hidden',
          isOpen && subheaders?.length > 0
            ? 'tw-flex tw-flex-col tw-gap-[12px] tw-pl-[8px] bs-tablet:tw-flex tw-mb-[1rem] bs-tablet:tw-gap-[8px]'
            : ''
        )}
      >
        {subheaders.map((subheader: ISubHeader, index: number) => (
          <a
            key={index}
            href={subheader.link}
            className="tw-w-full tw-font-book tw-leading-[19.12px] tw-not-italic tw-text-wrap tw-text-be-dark-gray hover:tw-cursor-pointer hover:tw-no-underline bs-tablet:tw-text-[14px]"
            style={{
              pointerEvents: subheader.link ? undefined : 'none',
            }}
          >
            {subheader.label}
          </a>
        ))}
      </div>
    </div>
  );
}
